import { useTranslation } from 'react-i18next';
import React from 'react';

import Modal from 'components/common/modal';
import { useModal } from 'hooks/use-modal';
import Filter from 'components/filter';

const AdvanceFilterModal = () => {
    const { isOpen, type, onClose } = useModal();
    const { t } = useTranslation();

    const isModalOpen = isOpen && type === 'advanced-filter';

    return (
        <Modal
            onClose={onClose}
            isOpen={isModalOpen}
            modalClassName="relative w-[926px] lg:w-[1092px] px-4 lg:px-8 bg-white rounded-2xl md:gap-x-1 lg:gap-x-[42px] py-3 md:py-5 max-h-[calc(100vh-20px)] mx-2 md:mx-0 overflow-y-auto"
        >
            <h1 className="text-brend text-[32px] leading-[44px] font-bold tracking-[3.84px] mb-4 md:mb-0">
                {t('filter.search')}
            </h1>
            <Filter advanced />
        </Modal>
    );
};

export default AdvanceFilterModal;
